import { jsxs as h, jsx as l } from "react/jsx-runtime";
import { useBreakpointValue as p, Tabs as T, chakra as u, TabList as $, Tab as k, TabPanels as R, TabPanel as g } from "@chakra-ui/react";
import { useRef as j, useEffect as P } from "react";
import { handleTabsReposition as i } from "./tabsFunctions.mjs";
const I = ({
  data: r,
  defaultIndex: n,
  index: o,
  listStyleProps: c,
  onChange: t,
  panelStyleProps: b,
  tabStyleProps: m,
  ...f
}) => {
  const s = j(null), a = p({ base: !0, md: !1 }, { fallback: "md" });
  P(() => {
    a && (o ? i(s, o) : n ? i(s, n) : i(s, 0));
  }, []);
  const d = (e) => {
    a && i(s, e), t && t(e);
  };
  return r.length > 0 ? /* @__PURE__ */ h(T, { onChange: d, defaultIndex: n, index: o, ...f, children: [
    /* @__PURE__ */ l(u.div, { className: "tabs-scrollable", ref: s, children: /* @__PURE__ */ l($, { ...c, children: r.map((e) => /* @__PURE__ */ l(
      k,
      {
        isDisabled: e.isDisabled,
        "data-testid": e.testId,
        ...m,
        children: e.tab
      },
      `${e.tab}`
    )) }) }),
    /* @__PURE__ */ l(R, { children: r.map((e) => /* @__PURE__ */ l(
      g,
      {
        "data-testid": e.testId && `${e.testId}-panel`,
        ...b,
        children: e.content
      },
      `${e.tab}-panel`
    )) })
  ] }) : null;
};
export {
  I as Tabs
};
